<template>
	<div class="home-banner margin-bottom-lg" v-if="bannerData">
		<WpImage v-if="bannerData.image" :image="bannerData.image" size="full" background :radius="false" cover />

		<div class="banner-content content-padding">
			<div class="container">
				<div class="container--b">
					<div class="inner padding-lg">
						<h1 v-if="bannerData.title" class="banner-title">
							{{ bannerData.title }}
						</h1>
						<div
							v-if="bannerData.description"
							class="banner-desc html-content"
							v-html="bannerData.description"
						></div>
						<ul v-if="bannerData.links && bannerData.links.length" class="button-list">
							<li v-for="({ link }, k) in bannerData.links" :key="k">
								<Button :acf-link="link" icon="arrowRight" theme="light" />
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import WpImage from '@/components/elements/WpImage'
import Button from '@/components/elements/Button'

import { mapGetters } from 'vuex'

export default {
	name: 'home-banner',
	computed: {
		...mapGetters(['currentPage', 'isFrontPage']),
		bannerData() {
			return this.currentPage && this.currentPage.acf && this.currentPage.acf.banner
				? this.currentPage.acf.banner
				: false
		},
	},
	components: {
		WpImage,
		Button,
	},
	data() {
		return {}
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
body.front-page {
	margin-top: 0;
}
.home-banner {
	position: relative;
	padding-bottom: 100px;
	overflow: hidden;
	.wp-image-vue.background div.image {
		padding-bottom: 0;
		height: 600px;
	}
	.button-list {
		margin-top: 40px;
		@include mquery($phone) {
			margin-top: 20px;
			flex-direction: column;
			li {
				margin-bottom: 15px;
				margin-right: 0;
				&:last-child {
					margin-bottom: 0;
				}
				.button {
					width: 100%;
				}
			}
		}
	}
	.banner-content {
		.container {
			position: relative;
		}
		.container--b {
			position: relative;
		}
		.banner-title {
			margin-top: 0;
			margin-bottom: 25px;
			@include mquery($phone) {
				margin-bottom: 15px;
			}
		}
		.inner {
			border-radius: $radius;
			background: var(--dark);
			color: #fff;
			width: 100%;
			position: absolute;
			z-index: 10;
			bottom: -100px;
		}
	}
}
</style>
